import React from 'react';

export default function IconNotif() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5625 23.8767C17.009 24.707 16.066 25.2502 15 25.2502C13.934 25.2502 12.991 24.707 12.4375 23.8767"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.25 21.15H4.75C4.75 21.15 7.825 17.5625 7.825 11.925C7.825 7.95825 11.0332 4.75 15 4.75C16.9885 4.75 18.772 5.5495 20.0738 6.85125C21.3755 8.14275 22.175 9.94675 22.175 11.925C22.175 17.5625 25.25 21.15 25.25 21.15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
